<template>
  <div class="profil">
        <!-- main-area -->
        <main class="fix">
            <!-- breadcrumb-area -->
            <section class="breadcrumb__area breadcrumb__bg">
                <div class="bg-img position-absolute top-0 start-0 w-100 h-100" data-background="assets/img/bg/breadcrumb_bg.jpg"></div>
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="breadcrumb__content">
                                <h2 class="title">Profil Pejabat Struktural</h2>
                                <nav aria-label="breadcrumb">
                                    <ol class="breadcrumb">
                                        <li class="breadcrumb-item"><router-link to="/">Beranda</router-link></li>
                                        <li class="breadcrumb-item active" aria-current="page">Profil Pejabat Struktural</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="breadcrumb__shape">
                    <img src="assets/img/images/breadcrumb_shape01.png" alt="Apexa" class="dark-opacity" />
                    <img src="assets/img/images/breadcrumb_shape02.png" alt="Apexa" class="rightToLeft dark-opacity" />
                    <img src="assets/img/images/breadcrumb_shape03.png" alt="Apexa" class="dark-opacity" />
                    <img src="assets/img/images/breadcrumb_shape04.png" alt="Apexa" class="dark-opacity" />
                    <img src="assets/img/images/breadcrumb_shape05.png" alt="Apexa" class="alltuchtopdown dark-opacity" />
                </div>
            </section>
            <!-- breadcrumb-area-end -->
            <!-- team-area -->
            <section class="team-area pt-120 pb-90">
                <div class="container">
                    <div class="team-item-wrap">
                        <div class="row justify-content-center">
                            <div v-for="data in list_data" :key="data.id" class="col-xl-3 col-lg-4 col-md-6 col-sm-8">
                                <div class="team-item">
                                    <div class="team-thumb">
                                        <a @click.prevent="selectData(data)" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#modalFoto">
                                            <img :src="file_path+data.foto" alt="Apexa" />
                                        </a>
                                    </div>
                                    <div class="team-content">
                                        <a @click.prevent="selectData(data)" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#modalFoto">
                                            <span style="text-align: center;">{{ data.judul }}</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- team-area-end -->
        </main>
        <!-- main-area-end -->
         <div id="modalFoto" class="modal fade" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                <div class="modal-header">
                    <i class="fas fa-user-circle"></i>
                    <h6 class="modal-title text-center w-100">{{ form.judul }}</h6>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body" style="display: flex; flex-direction: column; align-items: center;">
                    <img style="border-radius: 10px; max-width: 100%;" :src="file_path+form.foto" alt="Apexa" />
                    <p class="pt-20" style="align-self: flex-start; width: 100%; font-size: 16px; font-weight: 600;" v-html="form.isi"></p>
                </div>
                <div class="modal-footer">
                </div>
                </div>
            </div>
        </div>
  </div>
</template>

<script>

export default {
  name: 'Profil',

  data () {
    return {
        file_path: this.$store.state.url.URL_APP + "uploads/",
        unit_kerja: this.$store.state.UNIT_KERJA,
        cek_load_data : true,
        form : {
            id : '',
            judul : '',
            isi : '',
            foto : '',
            unit_kerja : '',
            createBy : '',
            createAt : '',
        },
        list_data: [],
        page_first: 1,
        page_last: 0,
        cari_value: "",
    }
  },

  methods: {
    getView: function() {
        console.log("datafjshdgjs");
        console.log(this.$store.state.url.URL_PEJABAT);
        
        console.log("datafjshdgjs");
        
        this.cek_load_data = true;
        fetch(this.$store.state.url.URL_PEJABAT + "view", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            },
            body: JSON.stringify({
            data_ke: this.page_first,
            cari_value: this.cari_value,
            })
        })
        .then(res => res.json())
        .then(res_data => {
            console.log(res_data);
            
            this.list_data = res_data.data;
            this.page_last = res_data.jml_data;
            this.cek_load_data = false;
        });
    },
    selectData: function(data) {
        console.log(data);
        this.form = {
            id : data.id,
            judul : data.judul,
            isi : data.isi,
            foto : data.foto,
            unit_kerja : data.unit_kerja,
            createBy : data.createBy,
            createAt : data.createAt,
        };
      },
  },

  mounted () {
    this.getView();
  }
}
</script>
